function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_5310",
  "data-name": "Path 5310",
  d: "M263.147,259.679l-6.074-6.074v6.183H250.89l6.074,6.074C261.641,265.56,262.845,264.356,263.147,259.679Z",
  transform: "translate(-250.89 -253.605)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_5311",
  "data-name": "Path 5311",
  d: "M281.908,259.679c.3,4.677,1.505,5.881,6.183,6.183l6.074-6.074h-6.183v-6.183Z",
  transform: "translate(-269.434 -253.605)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_5312",
  "data-name": "Path 5312",
  d: "M263.147,290.8c-.3-4.677-1.505-5.881-6.182-6.183L250.89,290.7h6.183v6.182Z",
  transform: "translate(-250.89 -272.149)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_5313",
  "data-name": "Path 5313",
  d: "M281.908,290.8l6.074,6.074V290.7h6.183l-6.074-6.074C283.413,284.924,282.21,286.127,281.908,290.8Z",
  transform: "translate(-269.434 -272.149)"
});

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.73,
    height: 24.73,
    viewBox: "0 0 24.73 24.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.756d3138.svg";
export { ForwardRef as ReactComponent };